// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
"use client";

import PropTypes from "prop-types";
import styled from "styled-components";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SVG = styled.svg.withConfig({
  componentId: "sc-6p9qnb-0"
})(["min-width:", ";max-width:", ";height:", ";"], ({
  $size
}) => $size, ({
  $size
}) => $size, ({
  $size
}) => $size);
const Clear = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => /*#__PURE__*/_jsxs(SVG, {
  ...props,
  $size: size,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  role: title ? 'img' : 'presentation',
  children: [title ? /*#__PURE__*/_jsx("title", {
    children: title
  }) : null, " ", /*#__PURE__*/_jsx("path", {
    fill: color,
    d: "M11.4 13.06l4.596 4.597a.749.749 0 1 0 1.06-1.06l-4.595-4.597 4.596-4.596a.749.749 0 1 0-1.06-1.06l-4.597 4.595-4.596-4.596a.749.749 0 1 0-1.06 1.06l4.595 4.597-4.596 4.596a.749.749 0 1 0 1.06 1.06l4.597-4.595z",
    children: " "
  })]
});
Clear.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,
  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,
  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default Clear;